import { ExternalIntegrationCard } from '../ExternalIntegrationCard/ExternalIntegrationCard'
import { ExternalIntegrationEnum, LinkedInIntegration } from 'api/clients/ExternalIntegrationsClient'
import { LinkedIn } from 'almanac-ui/icons'
import { CardButtons } from './CardButtons'
import { LinkedinInitialization } from 'components/IntegrationInitialization'
import { useModals } from 'almanac-ui/Modal'

export const LinkedinCard = ({
  integrations = [],
  isDisconnected = false,
}: {
  integrations?: LinkedInIntegration[]
  isDisconnected?: boolean
}) => {
  const { openModal } = useModals()

  return (
    <ExternalIntegrationCard
      title={'LinkedIn'}
      description={'Post directly to your LinkedIn account'}
      integrations={integrations}
      icon={<LinkedIn size={20} />}
      isDisconnected={isDisconnected}
      buttons={
        <CardButtons
          onConnect={() => openModal(LinkedinInitialization)}
          provider={ExternalIntegrationEnum.LinkedIn}
          isConnected={integrations.length > 0}
          integration={integrations[0]}
          isDisconnected={isDisconnected}
        />
      }
    />
  )
}
